import { render, staticRenderFns } from "./BillsDeleteModal.vue?vue&type=template&id=805d34dc&"
import script from "./BillsDeleteModal.vue?vue&type=script&lang=js&"
export * from "./BillsDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports